<template>
  <t-layout :showNav="false">
    <div class="page">
      <van-list
        v-if="!!list.length"
        class="common-list"
        v-model="loading"
        :finished="!hasMore"
        finished-text="没有更多了"
        @load="scrollReachBottom"
      >
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="infos" @click="haddleItem(item)">
            <div class="icon">
              <img :src="item.img" />
            </div>
            <div class="left">
              <div class="title">{{ item.title }}</div>
              <div class="tag">{{ item.points }}移动积分</div>
              <div class="sub-title">兑换时间 {{ item.date }}</div>
            </div>
            <div class="action">
              <div class="btn">立即查看</div>
            </div>
          </div>
        </div>
      </van-list>

      <div v-else class="empty">
        <img
          class="icon"
          src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/activity/points-lottery/img-blank.png"
        />
        <div class="text">暂无兑换，快去兑换吧~</div>
      </div>
    </div>
  </t-layout>
</template>

<script>
export default {
  name: 'activityLotteryList',
  components: {},
  data() {
    return {
      list: [],
      page: 1,
      hasMore: true,
      loading: false
    }
  },

  activated() {
    this.$store.commit('setTitle', '我的兑换')
    this.getList()
  },

  methods: {
    getList(refresh = true) {
      if (refresh) {
        this.page = 1
        this.hasMore = true
        this.list = []
      }

      let { page } = this
      let data = {
        page,
        limit: 20
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.$api.lotteryPoints
        .lotteryPointsOrderList(data)
        .then(result => {
          let res = result.data
          if (res.code == 0) {
            if (res.data) {
              let { list, next_page, has_more } = res.data

              list.map(item => {
                item.date = item.date.substring(0, 10)
              })

              this.list = this.list.concat(list || [])
              this.page = next_page
              this.hasMore = has_more == 1

              console.log('list', this.list)
            }
          }
        })
        .finally(() => {
          this.$toast.clear()
          this.loading = false
        })
    },

    scrollReachBottom() {
      this.getList(false)
    },

    haddleItem(item) {
      this.$router.push({
        path: '/activity/lottery/detail?id=' + item.id
      })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  color: #353738;
  background: #f9fafb;
  min-height: 100vh;
}

.common-list {
  padding: 24rpx;

  .item {
    width: 100%;
    background: #fff;
    padding: 24rpx;
    position: relative;
    margin-bottom: 24rpx;

    .infos {
      display: flex;
      align-items: center;
    }

    .icon {
      margin-right: 16rpx;
      width: 150rpx;
      height: 150rpx;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }
    }

    .left {
      flex: 1;

      .title {
        font-size: 30rpx;
        line-height: 30rpx;
        margin-bottom: 12rpx;
      }

      .tag {
        color: #ff5566;
        font-size: 26rpx;
        line-height: 26rpx;
        margin-bottom: 32rpx;
      }

      .sub-title {
        color: #9b9b9b;
        font-size: 26rpx;
        line-height: 26rpx;
      }
    }

    .action {
      width: 140rpx;
      padding-top: 48rpx;

      .btn {
        width: 100%;
        height: 48rpx;
        background: #fff;
        border-radius: 26rpx;
        text-align: center;
        line-height: 48rpx;
        font-size: 26rpx;
        color: #ff5566;
        box-shadow: 0 0 0 2rpx #ff5566;
      }
    }
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 300rpx;

  .icon {
    display: block;
    width: 514rpx;
    height: 298rpx;
    margin-bottom: 4rpx;
  }

  .text {
    font-size: 30rpx;
    line-height: 30rpx;
    text-align: center;
    margin-bottom: 4rpx;
    color: #9b9b9b;
  }
}
</style>
